@if (personalBillingTitle()) {
  <h6 [translate]="personalBillingTitle()"></h6>
}
<ul class="list-separated spacing-4" data-test="products-summary-personalBilling">
  @if (isPaymentInfoVisible()) {
    <li data-test="products-summary-personalBilling-payment">
      <mwe-headline [headlineNodeType]="headlineNodeType()" cssClass="font-size-16 lh-base" text="summary.paymentData" />
      @if (paymentIcon()) {
        <div class="row mb-1 mt-1">
          <div class="col col-auto">
            <div class="payment-badge">
              <img class="img-fluid" src="/assets/icons/payment/{{ paymentIcon() }}.svg" [alt]="paymentIcon()" />
            </div>
          </div>
          <div class="col">
            <p class="text--big mb-0" [innerHTML]="paymentText()"></p>
          </div>
        </div>
      }
    </li>
  }
  @if (stromGasMandate()) {
    <li>
      <mwe-headline [headlineNodeType]="headlineNodeType()" cssClass="font-size-16 lh-base" text="summary.stromGasMandate.title" />
      <p [innerHTML]="'summary.stromGasMandate.recipient' | translate"></p>
      <p [innerHTML]="'summary.stromGasMandate.id' | translate: { id: stromGasMandate().id }"></p>
      <p [innerHTML]="'summary.stromGasMandate.number' | translate: { number: stromGasMandate().number }"></p>
      <p
        [innerHTML]="'summary.stromGasMandate.mandateReference' | translate: { mandateReference: stromGasMandate().mandateReference }"
        class="mb-0"
      ></p>
    </li>
  }
  @if (fernWaermeMandate()) {
    <li>
      <mwe-headline [headlineNodeType]="headlineNodeType()" cssClass="font-size-16 lh-base" text="summary.fernWaermeMandate.title" />
      <p [innerHTML]="'summary.fernWaermeMandate.recipient' | translate"></p>
      <p [innerHTML]="'summary.fernWaermeMandate.id' | translate: { id: fernWaermeMandate().id }"></p>
      <p [innerHTML]="'summary.fernWaermeMandate.number' | translate: { number: fernWaermeMandate().number }"></p>
      <p
        [innerHTML]="'summary.fernWaermeMandate.mandateReference' | translate: { mandateReference: fernWaermeMandate().mandateReference }"
        class="mb-0"
      ></p>
    </li>
  }
  <li data-test="products-summary-personalBilling-eBilling">
    <mwe-headline [headlineNodeType]="headlineNodeType()" cssClass="font-size-16 lh-base" [text]="summaryBillingTitleText()" />
    @if (eRechnungInfo()?.isERechnungsEmpfaenger) {
      <p [innerHTML]="'summary.invoiceAddress.method.email' | translate | safeHtml" class="mb-1"></p>
      <p class="mb-1" data-test="products-summary-personalBilling-email">
        <b translate="summary.invoiceAddress.method.emailAddress"></b> {{ eRechnungInfo().rechnungEmail }}
      </p>
    } @else {
      <p
        [innerHTML]="'summary.invoiceAddress.method.post' | translate | safeHtml"
        data-test="products-summary-personalBilling-post"
        class="mb-1"
      ></p>
    }

    <p class="mb-1">
      @if (billingAddressTitleText()) {
        <b><span [innerHTML]="billingAddressTitleText() | translate | safeHtml"></span></b>
      }
      <span class="d-inline-block mb-2" data-test="products-summary-personalBilling-invoice-address">{{ formattedAddress() }}</span>
    </p>
  </li>
  @if (contactDataEmailAddress()) {
    <li data-test="products-summary-contactData-email">
      <mwe-headline [headlineNodeType]="headlineNodeType()" cssClass="font-size-16 lh-base" text="summary.contactDataEmailAddress" />
      <p class="text--big mb-0">
        <span data-test="products-summary-contactData-email-address">
          {{ contactDataEmailAddress() }}
        </span>
      </p>
    </li>
  }
  @if (additionalBulletPoints()) {
    @for (point of additionalBulletPoints(); track $index) {
      <li [attr.data-test]="point.id">
        <mwe-headline [headlineNodeType]="headlineNodeType()" cssClass="font-size-16 lh-base" [text]="point.title" />
        <p class="text--big mb-0">
          {{ point.text | translate }}
        </p>
      </li>
    }
  }
</ul>

@if (areBankAccountInfoTextsVisible()) {
  <mwe-new-bank-account-info-texts [hasSpotTariff]="hasSpotTariff()" [productCategories]="productCategories()" />
}

@if (invoiceInfoAlertMessage()) {
  <div class="mt-3" data-test="products-summary-personalBilling-eBillingAlert">
    <mwe-infobox [messageKey]="invoiceInfoAlertMessage()" [type]="'warning'" />
  </div>
}

@if (infoTextCardLabel()) {
  <div class="mt-3" data-test="products-summary-personalBilling-eBillingInfo">
    <mwe-infobox [messageKey]="infoTextCardLabel()" />
  </div>
}
